// export const REDDIT_CLIENT_ID = 'BS0KH3uaSnUQ-8_kO0hREg'
// export const REDDIT_REDIRECT_URL = 'https://app.nalapod.com/reddit/code'

// Detect environment based on hostname
const IS_PRODUCTION = window.location.hostname === 'app.nalapod.com'

// Reddit Configuration - Environment specific
export const REDDIT_CLIENT_ID = IS_PRODUCTION
  ? 'BS0KH3uaSnUQ-8_kO0hREg' // Replace with your production Reddit client ID
  : 'QGLuEXaHpAcoaaYOiyg8dw' // Replace with your local Reddit client ID

export const REDDIT_REDIRECT_URL = IS_PRODUCTION
  ? 'https://app.nalapod.com/reddit/code'
  : 'http://localhost:3000/reddit/code' 
